import type { Angle } from '@multiview/shared';
import type { Fixture } from './api/client.ts';

/** A perspective for a game on a channel, linked to the game for goal switching. */
export function fixtureAngle(fixture: Fixture, channelId: number): Angle {
  return {
    id: `draft-${channelId}-${Date.now()}`,
    label: `${fixture.homeTeam} – ${fixture.awayTeam}`,
    channelId,
    role: 'both',
    syncOffsetMs: 0,
    preferredQuality: 'auto',
    fixtureProvider: fixture.provider,
    fixtureExternalId: fixture.externalId,
  };
}
